export default {
  CLEAR_VALUE(state, pathWay) {
    state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]].value = "";
  },
  CHANGE_BLOCK(state, params) {
    let pathWay = params.path.split('_');
    if (pathWay.length !== 3) {
      return;
    }
    if (params.value !== '') {
      state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]].value = params.value;
    }

  },
  SET_CREATIVE_ET(state, values) {
    state.creativeET = values ?? []
  },
  UPDATE_TRIALS_DISCIPLINES(state, params) {
    let list = params.list;
    // Установки творческих испытаний (не выводятся, а ставятся автоматически)
    state.creativeET = [...new Set(params.creative)];
    let trialsIndex = state.fields[16]?.blocks[2]?.items?.findIndex(item => item.code === "ET_DISCIPLINE") ?? -1;
    if (trialsIndex !== -1) {
      trialsIndex = state.fields[16].blocks[2].items[trialsIndex].values = list;
    }
  },
  SET_USERID(state, params) {
    state.userId = params
  },
  UPDATE_SELECT_VALUES(state, params) {
    let pathWay = params.path.split('_');
    let thisBlock = state.fields[pathWay[0]].blocks[pathWay[1]];
    let nextBlock = state.fields[pathWay[0]].blocks[Number(pathWay[1]) + 1];
    switch (params.code) {
      case "OLYMPIAD_LIST_YEAR":
        let olympicProfileField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_LIST_OLYMPIAD");
        if (olympicProfileField !== -1) {
          thisBlock.items[olympicProfileField].value = "";
          thisBlock.items[olympicProfileField].values = params.values;

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[olympicProfileField - 1].value = params.value;
          }
        }
        break;
      case "REGISTRATION_REGION":
        let registrationRegion = thisBlock.items.findIndex(item => item.code === "REGISTRATION_REGION");
        if (registrationRegion !== -1) {
          thisBlock.items[registrationRegion].value = "";
        }
        break;
      case "OLYMPIAD_LIST_OLYMPIAD":
        let olympicDisciplineField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_LIST_PROFILE");
        if (olympicDisciplineField !== -1) {
          thisBlock.items[olympicDisciplineField].value = "";
          thisBlock.items[olympicDisciplineField].values = params.values;

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[olympicDisciplineField - 1].value = params.value;
          }

        }
        break;
      case "OLYMPIAD_LIST_PROFILE":
        let disciplineField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_LIST_SUBJECT");
        if (disciplineField !== -1) {
          thisBlock.items[disciplineField].value = "";
          thisBlock.items[disciplineField].values = params.values;

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[disciplineField - 1].value = params.value;
          }
        }
        break;
      case "OLYMPIAD_RU_YEAR":
        let ruProfileField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_RU_PROFILE");
        if (ruProfileField !== -1) {
          thisBlock.items[ruProfileField].value = "";
          thisBlock.items[ruProfileField].values = params.values;

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[ruProfileField - 1].value = params.value;
          }
        }
        break;
      case "OLYMPIAD_RU_PROFILE":
        if (params.values && params.values.id) {
          let ruOlympiadField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_RU_OLYMPIAD");
          let ruOlympiadProfileField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_RU_PROFILE");

          if (ruOlympiadField !== -1) {
            thisBlock.items[ruOlympiadField].value = params.values.id;
          }

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[ruOlympiadProfileField].value = params.value;
          }

        }
        break;
      case "OLYMPIAD_INTERNATIONAL_YEAR":
        let internationalProfileField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_INTERNATIONAL_PROFILE");
        if (internationalProfileField !== -1) {
          thisBlock.items[internationalProfileField].values = params.values;
          thisBlock.items[internationalProfileField].value = "";

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[internationalProfileField - 1].value = params.value;
          }
        }
        break;
      case "OLYMPIAD_UKR_YEAR":
        let ukrProfileField = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_UKR_PROFILE");
        if (ukrProfileField !== -1) {
          thisBlock.items[ukrProfileField].values = params.values;
          thisBlock.items[ukrProfileField].value = "";

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[ukrProfileField - 1].value = params.value;
          }
        }
        break;
      case "TARGETED_DIRECTION":
        let eduProgramField = thisBlock.items.findIndex(item => item.code === "TARGETED_PROGRAM");
        if (eduProgramField !== -1) {
          thisBlock.items[eduProgramField].values = params.values;
          thisBlock.items[eduProgramField].value = "";

          if (params.hasOwnProperty("mode")) {
            thisBlock.items[eduProgramField - 1].value = params.value;
          }
        }
        break;
      case "ACHIEVEMENT_CATHEGORY":
        let achievementField = thisBlock.items.findIndex(item => item.code === "ACHIEVEMENT_TYPE");
        if (achievementField !== -1) {
          thisBlock.items[achievementField].value = "";
          thisBlock.items[achievementField].values = params.values;
          if (params.hasOwnProperty("mode")) {
            thisBlock.items[achievementField - 1].value = params.value;
          }
        }
        break;
    }
  },
  SET_COMPETITIVE_GROUP(state, params) {
    state.competitiveGroups = params
  },
  SET_SELECTED_ITEM(state, params) {
    const selectedBwe = params.filter(item => {
      return item.bwet
    })
  },
  BLOCK_OLYMPIC_FIELDS(state) {
    const olympicBlocksArray = ['step_7_1', 'step_7_2', 'step_7_3', 'step_7_4']
    state.fields.map(field => {
      field.blocks.map(block => {
        if (olympicBlocksArray.includes(block.unique)) {
          block.items.map(field => {
            if (!field.code.includes('SCAN') && !field.code.includes('YEAR') && !field.code.includes('DATE')) {
              field.readonly = true
            }
          })
        }
      })
    })
  },
  UNBLOCK_OLYMPIC_FIELDS(state) {
    const olympicBlocksArray = ['step_7_1', 'step_7_2', 'step_7_3', 'step_7_4']
    state.fields.map(field => {
      field.blocks.map(block => {
        if (olympicBlocksArray.includes(block.unique)) {
          block.items.map(field => {
            field.readonly = false
          })
        }
      })
    })
  },
  INIT_EVENT(state) {
    const fields = state.fields
    const actionsButton = []
    const activeCheckBox = []
    let citizenship = ''

    //FIXME +
    fields.map(field => {
      field.blocks.map(block => {
        if (block.unique == "hostel" && block.items) {
          state.campuses = block.items[0].values
        }

        const button = block.items?.filter(item => item.value && item.type === "action_button")
        if (button && button.length) {
          actionsButton.push(button)
        }

        const checkbox = block.items?.filter(item => item.value && item.type === "checkbox")
        if (checkbox && checkbox.length) {
          activeCheckBox.push(checkbox)
        }
      })
    })

    state.actionsButton = actionsButton;
    state.activeCheckBox = activeCheckBox;
  },
  SET_SELECTED_COMPETITION(state) {
    const groups = state.competitionGroupList;
    groups.map(group => {
      group.items.map(item => {
        item['campusId'] = group.id;

        state.competitiveGroups.map(competition => {

          const result = item.types.filter(type => type.id === competition.id)

          if (result && result.length) {
            result[0].selected = true;
            if (competition?.specializationId) {
              const tempId = competition?.specializationId == '0' ? '' : competition.specializationId;
              result[0].specialisation = tempId ?? result[0].specialisation;
            }
            if (competition?.eduProgramId) {
              const tempId = competition?.eduProgramId == '0' ? '' : competition.eduProgramId;
              result[0].eduProgram = tempId ?? result[0].eduProgram;
            }
            if (competition.targeted) {
              result[0]['blockId'] = competition.targeted;
            }
            if (competition.specialQuota) {
              result[0]['blockId'] = competition.specialQuota;
            }
            if (competition.extraQuota) {
              result[0]['blockId'] = competition.extraQuota;
            }
            const isDuplicate = state.selectedCompetitionGroup.filter(i => i.campus === item.campus && i.title === item.title)

            if (!isDuplicate.length) {
              state.selectedCompetitionGroup.push(item);
            }
          }
        })
      })
    })
  },
  SET_GUID_SELECTED_COMPETITION(state, params) {
    if (state.selectedCompetitionGroup.length && Array.isArray(params)) {
      state.selectedCompetitionGroupGUID = params.map((e) => ({
        GUID: e.xmlIdCompetiveGroup ?? '',
        competitionGroupId: e.idCompetitiveGroup ?? 0
      }))
    } else {
      state.selectedCompetitionGroupGUID = []
    }
  },
  INIT_SELECTED_COMPETITION_GUID(state, params) {
    state.selectedCompetitionGroupGUID = params.map((e) => ({
      GUID: e.xmlIdCompetiveGroup ?? '',
      competitionGroupId: e.idCompetitiveGroup ?? 0
    }))
  },
  UPDATE_LAST_STEP_BLOCK_FIELDS(state, fields) {

    let blockFields = state.fields[state.fields.length - 1]?.blocks[0]?.items ?? [];

    let sourceField = Object.assign({}, blockFields[0]);
    blockFields.length = 0;
    fields.forEach(field => {
      let newField = Object.assign({}, sourceField);
      const value = !state.isChangedForm ? state.savedFiles[field.type] ?? "" : ""
      newField.code = field.code;
      newField.title = field.title;
      newField.placeType = field.type
      newField.value = value ? [value] : '';
      newField.id = Math.random().toString(16).slice(2);
      blockFields.push(newField);
    });
  },
  SET_STEP(state, step) {
    if (step === 7) {
      this.dispatch('needHelp/setLink', 'olympiads');
    } else if (step === 8) {
      this.dispatch('needHelp/setLink', 'achievements');
    } else {
      let isEdit = this.getters['needHelp/getIsEdit'];
      if (isEdit) {
        this.dispatch('needHelp/setLink', 'edit');
      } else {
        this.dispatch('needHelp/setLink', 'default');
      }
    }
    state.stepNum = step;
  },
  SET_ERRORS(state, error) {
    state.validationErrors.push(error);
  },
  CLEAR_ERRORS(state) {
    state.validationErrors = [];
  },
  UPDATE(state, params) {
    if (!params.path || !params.value) {
      return;
    }
    let pathWay = params.path.split('_');
    if (pathWay.length !== 3) {
      return;
    }
    try {
      let thisField = state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]];
      thisField.value = params.value;
    } catch (e) {
      console.error(e);
    }
  },
  UPDATE_COMPETITION_GROUP(state, params) {
    state.competitionGroupList = params;
  },
  SELECT_COMPETITION_GROUP(state, params) {
    if (Object.keys(params).includes('campus')) {
      let campusIndex = state.competitionGroupList.findIndex(item => item.id === params.campus);
      if (campusIndex === -1) {
        return
      }
      let cgIndex = state.competitionGroupList[campusIndex].items.findIndex(item => item.uniq === params.cg);
      if (cgIndex === -1) {
        return
      }
      let typeIndex = state.competitionGroupList[campusIndex].items[cgIndex].types.findIndex(item => item.id === params.type);
      if (typeIndex === -1) {
        return
      }
      state.competitionGroupList[campusIndex].items[cgIndex].types[typeIndex].selected = true;
      let searchInSelected = state.selectedCompetitionGroup.findIndex(item => item.uniq === params.cg && params.campus === item.campusId);
      if (searchInSelected === -1) {
        const campusId = state.competitionGroupList[campusIndex].id;
        state.selectedCompetitionGroup.push(
          Object.assign({ campusId: campusId }, state.competitionGroupList[campusIndex].items[cgIndex])
        );
      } else if (state.selectedCompetitionGroup[searchInSelected].types[typeIndex]) {
        state.selectedCompetitionGroup[searchInSelected].types[typeIndex].selected = true
      }
    } else {
      let cgIndex = state.selectedCompetitionGroup.findIndex(item => item.uniq === params.cg);
      if (cgIndex === -1) {
        return;
      }
      let typeIndex = state.selectedCompetitionGroup.types.findIndex(item => item.id === params.type);
      if (typeIndex === -1) {
        return
      }
      state.selectedCompetitionGroup.types[typeIndex].selected = true;
    }
  },
  SELECT_TARGET_FOR_COMPETITION(state, params) {
    state.selectedCompetitionGroup[params.index].types[params.typeIndex].blockId = params.value;
  },
  SELECT_QUOTA_FOR_COMPETITION(state, params) {
    state.selectedCompetitionGroup[params.index].types[params.typeIndex].blockId = params.value;
  },
  SELECT_EXTRA_FOR_COMPETITION(state, params) {
    state.selectedCompetitionGroup[params.index].types[params.typeIndex].blockId = params.value;
  },
  SELECT_SPECIALISATION(state, params) {
    state.selectedCompetitionGroup[params.index].types[params.typeIndex].specialisation = params.value;
  },
  SELECT_EDU_PROGRAMS(state, params) {
    state.selectedCompetitionGroup[params.index].types[params.typeIndex].eduProgram = params.value;
  },
  UNSELECT_COMPETITION_GROUP(state, params) {
    if (Object.keys(params).includes('block')) {
      state.selectedCompetitionGroup[params.block].types.forEach(item => item.selected = false);
      state.selectedCompetitionGroup.splice(params.block, 1);
    } else if (Object.keys(params).includes('campus')) {
      let campusIndex = state.competitionGroupList.findIndex(item => item.id === params.campus);
      if (campusIndex === -1) {
        return
      }
      let cgIndex = state.competitionGroupList[campusIndex].items.findIndex(item => item.uniq === params.cg);
      if (cgIndex === -1) {
        return
      }
      let typeIndex = state.competitionGroupList[campusIndex].items[cgIndex].types.findIndex(item => item.id === params.type);
      if (typeIndex === -1) {
        return
      }
      state.competitionGroupList[campusIndex].items[cgIndex].types[typeIndex].selected = false;
      let searchOneSelected = state.competitionGroupList[campusIndex].items[cgIndex].types.findIndex(item => item.selected === true);
      if (searchOneSelected !== -1) {
        return;
      }
      let findInSelected = state.selectedCompetitionGroup.findIndex(item => item.uniq === params.cg && params.campus === item.campusId);
      if (findInSelected === -1) {
        return;
      }
      state.selectedCompetitionGroup.splice(findInSelected, 1);
    } else {
      let cgIndex = state.selectedCompetitionGroup.findIndex(item => item.uniq === params.cg);
      if (cgIndex === -1) {
        return
      }
      let typeIndex = state.selectedCompetitionGroup[cgIndex].types.findIndex(item => item.id === params.type);
      if (typeIndex === -1) {
        return
      }
      state.selectedCompetitionGroup[cgIndex].types[typeIndex].selected = false;
      let searchOneSelected = state.selectedCompetitionGroup[cgIndex].types.findIndex(item => item.selected === true);
      if (searchOneSelected !== -1) {
        return;
      }
      state.selectedCompetitionGroup.splice(cgIndex, 1);
    }
  },

  SET(state, list) {
    state.birthDate = this.$auth.user.birthDay;
    state.fields = list
  },
  SET_REQUIRED_STEPS(state, list) {
    state.requiredSteps = list;
  },
  SET_STATUS(state, params) {
    state.status[params.step] = params.status
  },
  SET_ITEM_VALUES(state, { options, values }) {
    const {
      step,
      blockIndex,
      itemIndex,
      blockUnique,
      itemCode,
    } = options
    const field = state.fields.find((f) => f.number === step)
    let block;
    let item;

    if (blockUnique) {
      block = field?.blocks?.find((e) => e.unique === blockUnique);
    } else {
      block = field?.blocks[blockIndex];
    }

    if (itemCode) {
      item = block?.items?.find((e) => e.code === itemCode);
    } else {
      item = block?.items[itemIndex];
    }
    if (item) {
      item.values = values
    }
  },
  SET_BLOCK_VALUE(state, { options, value }) {
    const {
      step,
      blockIndex,
      blockFieldName,
      blockUnique,
    } = options;
    const field = state.fields.find((f) => f.number == step)
    let block;

    if (blockUnique) {
      block = field?.blocks?.find((e) => e.unique === blockUnique);
    } else {
      block = field?.blocks[blockIndex];
    }
    if (block && blockFieldName) {
      block[blockFieldName] = value
    }
  },
  SET_ITEM_VALUE(state, { options, value }) {
    const {
      step,
      blockIndex,
      itemIndex,
      itemFieldName,
      blockUnique,
      itemCode,
    } = options
    const field = state.fields.find((f) => f.number == step)
    let block;
    let item;

    if (blockUnique) {
      block = field?.blocks?.find((e) => e.unique === blockUnique);
    } else {
      block = field?.blocks[blockIndex];
    }

    if (itemCode) {
      item = block?.items?.find((e) => e.code === itemCode);
    } else {
      item = block?.items[itemIndex];
    }
    if (item) {
      if (itemFieldName) {
        item[itemFieldName] = value
      } else {
        item.value = value
      }
    }
  },
  SET_REFS(state, data) {
    state.refs = data;
  },
  ACTION_BUTTON_BASE(state, params) {
    let step = state.fields.filter((object) => {
      return object.number === params.step;
    });

    if (step.length === 0) {
      return;
    }
    step = step[0];

    let block = step.blocks.filter((object) => {
      return object.unique === params.target;
    });

    if (block.length === 0) {
      return;
    }

    block = block[0];
    let displayNow = params.value ? !block.display_default : block.display_default;

    if (displayNow && block.multiple) {
      block.actionTrigger = true
    }
    block.display = displayNow;

    block.items.forEach((field) => {
      field.required = displayNow ? field.default_required : false;
    });
  },
  SET_VISIBLE_ITEM(state, options) {
    const { step, blockUnique, itemCode, isHide } = options
    const field = state.fields.find((e) => e.number == step)
    if (!field) return

    const block = field.blocks.find((e) => e.unique == blockUnique)

    if (!block) return;

    const item = block.items.find((e) => e.code == itemCode)

    if (!item) return

    item.hide = isHide
  },
  ACTION_BUTTON_REGISTER_RESIDENCY(state, params) {
    let step = state.fields.filter((object) => {
      return object.number === params.step;
    });
    if (step.length === 0) {
      return;
    }
    step = step[0];

    state.residencyFill = params.value

    let donor = null,
      recipient = null;
    for (let i in step.blocks) {
      if (params.value && step.blocks[i].unique === 'step_1_2') {
        donor = step.blocks[i];
      }
      if (step.blocks[i].unique === 'step_1_3') {
        recipient = step.blocks[i];
      }
      if ((recipient && !params.value) || (recipient && donor)) {
        break;
      }
    }

    if ((!donor && params.value) || !recipient) {
      return;
    }

    recipient.display = !params.value;
  },
  ACTION_BUTTON_RECOGNITION(state, params) {
    let step = state.fields.filter((object) => {
      return object.number === params.step;
    });
    if (step.length === 0) {
      return;
    }
    step = step[0];
    let block;
    for (let i in step.blocks) {
      // params.value &&
      if (step.blocks[i].unique === 'step_5_3_1') {
        block = step.blocks[i];
        break;
      }
    }
    if (!block) {
      return;
    }
    let itemIndex = block.items.findIndex((item) => {
      return item.code === "EDUCATION_SCAN_RECOGNITION"
    });
    if (itemIndex < 0) {
      return;
    }
    //console.log('params.value :>> ', params.value);
    // let hideNow = params.value ? block.items[itemIndex].hide_default : !block.items[itemIndex].hide_default;
    let hideNow = params.value ? false : true;
    //console.log(' block.items[itemIndex].hide :>> ', hideNow, block.items[itemIndex].hide);
    block.items[itemIndex].hide = hideNow;
    // block.items[itemIndex].required = hideNow ? false : block.items[itemIndex].default_required;
    block.items[itemIndex].required = hideNow ? false : true;

  },
  ACTION_BUTTON_HSE_STUDENT(state, params) {
    let step = state.fields.filter((object) => {
      return object.number === params.step;
    });

    let block;
    let topBlock;
    const blocks = step[0].blocks

    for (let i in blocks) {

      //являюсь или нет выпускником лицея, уровень образования, страна выдачи
      if (blocks[i].unique === 'step_5_1') {
        topBlock = blocks[i]
      //данные диплома, оценки
      } else if (blocks[i].unique === 'step_5_2') {
        block = blocks[i];
      }

    }

    if (!block && !topBlock) {
      return;
    }

    for (let i in topBlock.items) {

      if (topBlock.items[i].code === 'EDUCATION_LEVEL') {
        const levelValue = topBlock.items[i].values.filter(item => item.code === state.guidIsHseEducationLevel)
        topBlock.items[i].value = params.value ? levelValue[0]?.id : "";
        // localStorage.setItem(`${state.userId}/field/${topBlock.items[i].code}`, `${params.value ? levelValue[0].id : ""}`);
      }
      else if (topBlock.items[i].code === 'EDUCATION_DOCUMENT_COUNTRY') {
        const countryValue = topBlock.items[i].values.filter(item => item.code === state.guidIsHseEducationCountry);
        topBlock.items[i].value = params.value ? countryValue[0].id : "";
        // localStorage.setItem(`${state.userId}/field/${topBlock.items[i].code}`, `${params.value ? countryValue[0].id : ""}`);
      }
    }

    params.value ? block.display = true : block.display = false;

    for (let i in block.items) {

      block.items[i].required = block.items[i].default_required;

      if (block.items[i].code === 'EDUCATION_DOCUMENT_TYPE') {
        const typeValue = block.items[i].values.filter(item => item.code === state.guidIsHseEducationDocType);

        block.items[i].value = params.value ? typeValue[0].id : "";
        // localStorage.setItem(`${state.userId}/field/${block.items[i].code}`, `${params.value ? typeValue[0].id : ""}`);
      }
      else if (block.items[i].code === 'EDUCATION_DOCUMENT_REGION') {
        const regionValue = block.items[i].values.filter(item => item.code === state.guidIsHseEducationRegion);

        block.items[i].value = params.value ? regionValue[0].id : "";
        // localStorage.setItem(`${state.userId}/field/${block.items[i].code}`, `${params.value ? regionValue[0].id : ""}`);
      }
      else if (block.items[i].code === 'EDUCATION_DOCUMENT_CITY') {
        block.items[i].value = params.value ? state.guidIsHseEducationCity : "";
        // localStorage.setItem(`${state.userId}/field/${block.items[i].code}`, `${params.value ? state.guidIsHseEducationCity : ""}`);
      }
      else if (block.items[i].code === 'EDUCATION_ORGANIZATION_TYPE') {
        const orgtypeValue = block.items[i].values.filter(item => item.code === state.guidIsHseEducationOrgType);

        block.items[i].value = params.value ? orgtypeValue[0].id : "";
        // localStorage.setItem(`${state.userId}/field/${block.items[i].code}`, `${params.value ? orgtypeValue[0].id : ""}`);
      }
      else if (block.items[i].code === 'EDUCATION_ORGANIZATION_NAME') {
        block.items[i].value = params.value ? state.guidIsHseEducationOrgName : "";
        // localStorage.setItem(`${state.userId}/field/${block.items[i].code}`, `${params.value ? state.guidIsHseEducationOrgName : ""}`);
      }
      else if (block.items[i].code === 'EDUCATION_SCANS') {
        block.items[i].required = params.value ? true : block.items[i].default_required;
      }
    }
  },
  FILL(state, params) {
    state.residencyFill = !params.value
  },
  SAVE(state, params) {
    if (!params.path || typeof params.value === 'undefined') {
      return;
    }

    let pathWay = params.path.split('_');
    if (pathWay.length !== 3) {
      return;
    }
    try {
      let thisField = state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]];
      const step = state.fields[pathWay[0]]
      thisField.value = params.value ?? thisField.value;
      // if (!params.hasOwnProperty('mode') && state.userId && !state.fields[pathWay[0]].blocks[pathWay[1]].multiple && thisField.type !== "file") {
      //     if (thisField.type === "checkbox") {
      //         if (thisField.code === 'HSE_BRANCH' || thisField.code === "ET_DISCIPLINE") {
      //             if (params.value) {
      //                 localStorage.setItem(`${state.userId}/checkbox/${thisField.code}`, `${params.value}`);
      //             } else {
      //                 localStorage.setItem(`${state.userId}/checkbox/${thisField.code}`, '');
      //             }
      //         } else {
      //             localStorage.setItem(`${state.userId}/checkbox/${thisField.code}`, `${params.value}`);
      //         }
      //     } else {
      //         localStorage.setItem(`${state.userId}/field/${thisField.code}`, `${params.value}`);
      //     }
      // }

      const DUPLICATES = {
        'DOCUMENT_CITIZENSHIP': [2, 0],
        'DOCUMENT_BIRTHPLACE': [2, 0],
        'DOCUMENT_TYPE': [2, 0],
        'DOCUMENT_SERIAL': [2, 0],
        'DOCUMENT_NUMBER': [2, 0],
        'DOCUMENT_GIVENBY': [2, 0],
        'DOCUMENT_DIVISION_CODE': [2, 0],
        'DOCUMENT_DATE': [2, 0]
      };


      if (Object.keys(DUPLICATES).includes(thisField.code)) {
        let blockPath = DUPLICATES[thisField.code];
        let duplicateBlock = state.fields[blockPath[0]].blocks[blockPath[1]];
        let field = duplicateBlock.items.find((item) => {
          return item.code === thisField.code;
        });
        if (!field) {
          return;
        }

        field.value = thisField.value;
      }

      function setProperty(type, code, property, value) {
        const eq = state.guidDocumentsRf.includes(state.typeOfDocument);
        const eqRegCountry = state.guidRf === state.registrationCountry;
        const eqResCountry = state.guidRf === state.residencyCountry;

        function set(item, itemProperty, itemValue) {
          item[itemProperty] = itemValue;
        }

        state.fields.forEach(field => {
          if (type === "block") {
            const thisBlock = field.blocks.find(block => block.unique === code);

            if (thisBlock) {

              if (code === "step_6_2") {
                if (property === 'display') {
                  set(thisBlock, 'display', value)
                }
                thisBlock.items.forEach(
                  item => {
                    set(item, "required", value ? item.default_required : false);
                  })
              } else if (code === "step_1_1" || code === "step_3_1") {
                thisBlock.items.forEach(
                  item => {
                    if (['DOCUMENT_SERIAL', 'DOCUMENT_NUMBER', 'DOCUMENT_DIVISION_CODE'].includes(item.code)) {
                      if (property === "required") {
                        set(item, "required", eq ? item.default_required : false);
                      } else if (property === "type") {
                        set(item, "type", eq ? 'number' : 'text');
                      }
                    }
                  }
                )
              } else if (code === "representative" || code === "attorny") {
                thisBlock.items.forEach(
                  item => {
                    const eqRfDoc = state.guidDocumentsRf.includes(state.refs[value]);

                    if (['ATTORNY_DOCUMENT_SERIAL',
                      'ATTORNY_DOCUMENT_NUMBER',
                      'REPRESENTATIVE_DOCUMENT_SERIAL',
                      'REPRESENTATIVE_DOCUMENT_NUMBER'
                    ].includes(item.code)) {
                      if (property === "required") {
                        set(item, "required", eqRfDoc ? item.default_required : false);
                      } else if (property === "readonly") {
                        set(item, "readonly", false);
                      }
                    }
                  }
                )
              } else if (code === "step_1_2" || code === "step_1_3" || code === "representative2" || code === "attorny2") {
                thisBlock.items.forEach(
                  item => {
                    if (item.code === "REGISTRATION_REGION"
                      || item.code === "RESIDENCY_REGION"
                      || "REPRESENTATIVE_REGION"
                      || "ATTORNY_REGION") {
                      const eqRef = state.guidRf === state.refs[value];

                      if (property === "required") {
                        switch (item.code) {
                          case "REGISTRATION_REGION":
                            set(item, "required", eqRegCountry ? item.default_required : false);
                            break;
                          case "RESIDENCY_REGION":
                            set(item, "required", eqResCountry ? item.default_required : false);
                            break;
                          case "REPRESENTATIVE_REGION":
                          case "ATTORNY_REGION":
                            set(item, "required", eqRef ? item.default_required : false);
                            break;
                        }
                      } else if (property === "readonly") {
                        switch (item.code) {
                          case "REGISTRATION_REGION":
                            set(item, "readonly", eqRegCountry ? false : item.default_readonly);
                            break;
                          case "RESIDENCY_REGION":
                            set(item, "readonly", eqResCountry ? false : item.default_readonly);
                            break;
                          case "REPRESENTATIVE_REGION":
                          case "ATTORNY_REGION":
                            set(item, "readonly", eqRef ? false : item.default_readonly);
                            break;
                        }
                      }
                    }
                  }
                )
              } else {
                set(thisBlock, property, value);
              }
            }
          } else if (type === "item") {
            field.blocks.forEach(block => {
              const thisItem = block.items.find(item => item.code === code);

              if (thisItem) {
                set(thisItem, property, value);
              }
            })
          }
        })

      }

      if (thisField.code === 'DOCUMENT_CITIZENSHIP') {
        const isRussianCitizen = state.guidRf === state.refs[thisField.value]
        const eq = state.guidBlr === state.refs[thisField.value];

        //FIXME +
        setProperty("item", "IS_COPATRIOT", "readonly", isRussianCitizen);
        setProperty("block", "step_6_2", "display", eq);

      } else if (thisField.code === 'DOCUMENT_TYPE') {
        state.typeOfDocument = state.refs[thisField.value]; // get guid by value (id)
        // FIXME +

        setProperty("block", "step_1_1", "required", "");
        setProperty("block", "step_3_1", "required", "");
        setProperty("block", "step_1_1", "type", "");
        setProperty("block", "step_3_1", "type", "");

        const eqRfPassport = state.typeOfDocument === state.guidPassportRf;

        if (eqRfPassport) {
          setProperty("item", "UF_SNILS", "required", true);
          setProperty("item", "SCAN_SNILS", "required", true);
        }
        else {
          setProperty("item", "UF_SNILS", "required", false);
          setProperty("item", "SCAN_SNILS", "required", false);
        }
      } else if (thisField.code === 'PERSONAL_BIRTHDAY') {
        const arDate = thisField.value.split('.');
        const valDate = new Date(arDate[2] + '-' + arDate[1] + '-' + arDate[0]);
        state.birthDate = valDate.toISOString();
      } else if (thisField.code === 'DOCUMENT_BEFORE_TYPE') {
        state.typeOfPrevDocument = state.refs[thisField.value];
      } else if (thisField.code === 'REPRESENTATIVE_DOCUMENT_TYPE') {
        // FIXME +
        setProperty("block", "representative", "required", thisField.value);
        setProperty("block", "representative", "readonly", thisField.value);
      } else if (thisField.code === 'ATTORNY_DOCUMENT_TYPE') {
        // FIXME +
        setProperty("block", "attorny", "required", thisField.value);
        setProperty("block", "attorny", "readonly", thisField.value);
      } else if (thisField.code === 'REGISTRATION_COUNTRY') {
        state.registrationCountry = state.refs[thisField.value]; // get guid by value (id)
        // FIXME +
        setProperty("block", "step_1_2", "required", "");
        setProperty("block", "step_1_2", "readonly", "");
      } else if (thisField.code === 'RESIDENCY_COUNTRY') {
        state.residencyCountry = state.refs[thisField.value]; // get guid by value (id)
        // FIXME +
        setProperty("block", "step_1_3", "required", "");
        setProperty("block", "step_1_3", "readonly", "");
      } else if (thisField.code === 'REPRESENTATIVE_COUNTRY') {
        // FIXME +
        setProperty("block", "representative2", "required", thisField.value);
        setProperty("block", "representative2", "readonly", thisField.value);
      } else if (thisField.code === 'ATTORNY_COUNTRY') {
        // FIXME +
        setProperty("block", "attorny2", "required", thisField.value);
        setProperty("block", "attorny2", "readonly", thisField.value);
      } else if (thisField.code === 'EDUCATION_DOCUMENT_COUNTRY') {
        const baseCountries = [
          state.guidRf
        ];
        const codeItem = 'EDUCATION_DOCUMENT_TYPE'

        let baseBlockIndex = step.blocks.findIndex((item) => {
          return item.unique === 'step_5_2';
        });
        let nonBaseBlockIndex = step.blocks.findIndex((item) => {
          return item.unique === 'step_5_3_1';
        });

        if (baseCountries.includes(state.refs[thisField.value])) {
          if (baseBlockIndex && baseBlockIndex > 0) {
            step.blocks[baseBlockIndex].display = true;
            for (let i in step.blocks[baseBlockIndex].items) {
              step.blocks[baseBlockIndex].items[i].required = step.blocks[baseBlockIndex].items[i].default_required;
            }
          }
          if (nonBaseBlockIndex && nonBaseBlockIndex > 0) {
            step.blocks[nonBaseBlockIndex].display = false;
            for (let i in step.blocks[nonBaseBlockIndex].items) {
              step.blocks[nonBaseBlockIndex].items[i].required = false;
            }
          }
        } else {
          if (baseBlockIndex && baseBlockIndex > 0) {
            step.blocks[baseBlockIndex].display = false;
            for (let i in step.blocks[baseBlockIndex].items) {
              step.blocks[baseBlockIndex].items[i].required = false;
            }
            const item = step.blocks[baseBlockIndex].items.find((e) => e.code === codeItem)
            if (item) {
              const val = item.values.find((e) => e.code === state.guidForeignDocTyp)
              item.value = val?.id ?? item.value
            }
          }
          if (nonBaseBlockIndex && nonBaseBlockIndex > 0) {
            step.blocks[nonBaseBlockIndex].display = true;
            for (let i in step.blocks[nonBaseBlockIndex].items) {
              if (step.blocks[nonBaseBlockIndex].items[i].code === 'EDUCATION_DOCUMENT_SERIAL') {
                step.blocks[nonBaseBlockIndex].items[i].required = false
              }
              else if (step.blocks[nonBaseBlockIndex].items[i].code === 'EDUCATION_SCAN_ORIGIN') {
                step.blocks[nonBaseBlockIndex].items[i].required = true
              }
              else {
                if (step.blocks[nonBaseBlockIndex].items[i].code !== "EDUCATION_SCAN_RECOGNITION") {
                  step.blocks[nonBaseBlockIndex].items[i].required = step.blocks[baseBlockIndex].items[i].default_required;
                }
              }
            }
          }
        }
      }
      else if (thisField.code === 'EDUCATION_WITH_HONORS') {
        //FIXME +
        const educationSecondBlock = state.fields[pathWay[0]].blocks[[pathWay[1]]];
        const markThreeField = educationSecondBlock.items.filter(item => item.code === "EDUCATION_SCORE_3")[0];
        const markFourField = educationSecondBlock.items.filter(item => item.code === "EDUCATION_SCORE_4")[0];
        const markFiveField = educationSecondBlock.items.filter(item => item.code === "EDUCATION_SCORE_5")[0];

        if (thisField.value) {
          markThreeField.value = ''
          markFourField.value = ''
          markFiveField.value = ''
          markThreeField.readonly = true
          markFourField.readonly = true
          markFiveField.readonly = true
        } else {
          markThreeField.readonly = false
          markFourField.readonly = false
          markFiveField.readonly = false
        }
      } else if (thisField.code === 'BENEFIT_DATE_INDEFINITELY') {
        const block = state.fields[pathWay[0]].blocks[pathWay[1]];
        let benefitDateByIndex = block.items.findIndex(item => item.code === "BENEFIT_DATE_TO");
        if (benefitDateByIndex !== -1) {
          const benefitDateBy = block.items[benefitDateByIndex];
          if (thisField.value) {
            benefitDateBy.value = ''
            benefitDateBy.readonly = true
          } else {
            benefitDateBy.readonly = false
          }
        }
      } else if (thisField.code === "BENEFIT_TYPE") {
        const block = state.fields[pathWay[0]].blocks[pathWay[1]];
        let guid = state.refs[thisField.value];

        let toShowFields = [];
        const allFields = [
          'BENEFIT_ORPHANAGE_DOCUMENT', 'BENEFIT_ORPHANAGE_CATEGORY',
          'BENEFIT_DISABILITY_DOCUMENT', 'BENEFIT_DISABILITY_GROUP', 'BENEFIT_DISABILITY_CATEGORY', 'BENEFIT_DISABILITY_COMMENT',
          'BENEFIT_COMBANANT_DOCUMENT', 'BENEFIT_COMBANANT_CATEGORY'
        ];
        if (guid) {
          if (state.guidBenefitTypes.orphanage.includes(guid)) {
            toShowFields = ['BENEFIT_ORPHANAGE_DOCUMENT', 'BENEFIT_ORPHANAGE_CATEGORY'];
          } else if (state.guidBenefitTypes.disability.includes(guid)) {
            toShowFields = ['BENEFIT_DISABILITY_DOCUMENT', 'BENEFIT_DISABILITY_GROUP', 'BENEFIT_DISABILITY_CATEGORY', 'BENEFIT_DISABILITY_COMMENT']
          } else if (state.guidBenefitTypes.combanant.includes(guid)) {
            toShowFields = ['BENEFIT_COMBANANT_DOCUMENT', 'BENEFIT_COMBANANT_CATEGORY'];
          }
        }
        block.items.forEach(item => {
          item.hide = (toShowFields.includes(item.code) ? false : item.hide_default);
          item.required = (toShowFields.includes(item.code) ? item.default_required : (allFields.includes(item.code) ? false : item.default_required));
        });
      } else if (thisField.code === "EDUCATION_DOCUMENT_TYPE") {
        let blockIndex;
        let fieldIndex;
        for (let i = 0; i < step.blocks.length; i++) {
          fieldIndex = step.blocks[i].items.findIndex(item => item.code === "EDUCATION_SUBMIT");
          if (fieldIndex !== -1) {
            blockIndex = i;
            break;
          }
        }
        if (fieldIndex === -1 || !blockIndex) {
          return;
        }
        const Field = step.blocks[blockIndex].items[fieldIndex];
        let val = state.refs[thisField.value];
        if (state.guidEducationDocTypes.includes(val)) {
          Field.hide = false;
          Field.required = Field.default_required;
        } else {
          Field.hide = Field.hide_default;
          Field.required = false;
        }
      }
      //FIXME +
      // разблокировка полей олимпиад по порядку. Перечневая
      else if (thisField.code === "OLYMPIAD_LIST_YEAR") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_OLYMPIAD", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_LIST_OLYMPIAD") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_PROFILE", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_LIST_PROFILE") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_SUBJECT", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_LIST_SUBJECT") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_CLASS", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_LIST_CLASS") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_RESULT", "readonly", false)
        }
      } else if (thisField.code === "OLYMPIAD_LIST_RESULT") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_LIST_NUMBER", "readonly", false);
          setProperty("item", "OLYMPIAD_LIST_DATE", "readonly", false);
        }
        //FIXME +
        // разблокировка полей олимпиад по порядку. Всероссийская
      } else if (thisField.code === "OLYMPIAD_RU_YEAR") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_RU_PROFILE", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_RU_PROFILE") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_RU_CLASS", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_RU_CLASS") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_RU_RESULT", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_RU_RESULT") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_RU_NUMBER", "readonly", false);
          setProperty("item", "OLYMPIAD_RU_DATE", "readonly", false);
          setProperty("item", "OLYMPIAD_RU_SCAN", "readonly", false);

        }
        //FIXME +
        // разблокировка полей олимпиад по порядку. Международная
      } else if (thisField.code === "OLYMPIAD_INTERNATIONAL_YEAR") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_INTERNATIONAL_PROFILE", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_INTERNATIONAL_PROFILE") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_INTERNATIONAL_RESULT", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_INTERNATIONAL_RESULT") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_INTERNATIONAL_TEAM", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_INTERNATIONAL_TEAM") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_INTERNATIONAL_NAME", "readonly", false);
          setProperty("item", "OLYMPIAD_INTERNATIONAL_NUMBER", "readonly", false);
          setProperty("item", "OLYMPIAD_INTERNATIONAL_DATE", "readonly", false);
          setProperty("item", "OLYMPIAD_INTERNATIONAL_DIPLOMA", "readonly", false);
        }
        //FIXME +
        // разблокировка полей олимпиад по порядку. Всеукраинская
      } else if (thisField.code === "OLYMPIAD_UKR_YEAR") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_UKR_PROFILE", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_UKR_PROFILE") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_UKR_RESULT", "readonly", false);
        }
      } else if (thisField.code === "OLYMPIAD_UKR_RESULT") {
        if (thisField.value) {
          setProperty("item", "OLYMPIAD_UKR_NAME", "readonly", false);
          setProperty("item", "OLYMPIAD_UKR_NUMBER", "readonly", false);
          setProperty("item", "OLYMPIAD_UKR_DATE", "readonly", false);
        }
      } else if (thisField.code === 'ET_HAVE') {
        setProperty('item', 'ET_HAVE', 'readonly', params.readonly ?? false)
      }
    } catch (e) {
      return;
    }
  },
  SAVE_FILE(state, params) {
    if (!params.path || !params.files) {
      return;
    }

    let pathWay = params.path.split('_');

    if (pathWay.length !== 3) {
      return;
    }

    try {
      let thisField = state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]];

      thisField.value ?
        (thisField.multiple && !params.hasOwnProperty("mode") ?
          params.files.map(file => thisField.value.push(file))
          : thisField.value = params.files) :
        thisField.value = params.files;

      // if(!state.fields[pathWay[0]].blocks[pathWay[1]].multiple){
      //     localStorage.setItem(`file/${thisField.code}`, JSON.stringify(thisField.value));
      // }
    }
    catch (e) {
      console.error(e);
    }
  },
  DELETE_FILE(state, params) {
    let pathWay = params.path.split('_');
    if (pathWay.length !== 3) {
      return;
    }
    try {
      let thisField = state.fields[pathWay[0]].blocks[pathWay[1]].items[pathWay[2]];
      thisField.value = thisField.value.filter((item, index) => index !== params.index);
      // localStorage.setItem(`file/${thisField.code}`, JSON.stringify(thisField.value));

    } catch (e) {
      console.error(e);
    }
  },
  FILTER_CAMPUSES(state) {
    if (state.selectedCompetitionGroup.length) {
      // фильтр кампусов, показываются только те, в которых выбрано кг на бюджете/целевом/спецквоте
      // если таких нет - показывать только Альтернативное размещение, если есть мин. 1 кг в Москве
      let campusArray = []
      let allCampuses = []
      const campusFinancingTypes = ['Бюджетное', 'Целевое', 'Особая квота']
      state.selectedCompetitionGroup.forEach(cg => {
        cg.types.forEach(type => {
          if (campusFinancingTypes.includes(type.label) && type.selected && !campusArray.includes(cg.campus)) {
            campusArray.push(cg.campus)
          }
          allCampuses.push(cg.campus)
        })
      })
      //FIXME +
      function setProperty(code, property, value) {
        state.fields.forEach(field => {
          field.blocks.forEach(block => {
            if (!Array.isArray(block.items)) return;

            const thisItem = block.items.find(item => item.code === code);

            if (thisItem) {
              switch (property) {
                case "hide":
                  thisItem.hide = value;
                  break;
                case "values":
                  thisItem.values = value;
                  break;
              }
            }
          });
        });
      }

      if (campusArray.length) {
        setProperty("HSE_HOSTEL", "hide", false);
        const filteredCampuses = state.campuses.filter(campus => campusArray.includes(campus.label));
        setProperty("HSE_BRANCH", "values", [...filteredCampuses]);
      } else {
        setProperty("HSE_HOSTEL", "hide", true);
        setProperty("HSE_BRANCH", "values", [...state.campuses]);
      }

      if (allCampuses.includes('Москва')) {
        setProperty("NEED_ALT_HOSTEL", "hide", false);
      }
      else {
        setProperty("NEED_ALT_HOSTEL", "hide", true);
      }
    }
  },
  INIT_CONST_VALUES(state) {
    try {
      state.guidRf = process.env.NUXT_ENV_C_GUID_RF || state.guidRf;
      state.guidDocumentsRf = JSON.parse(process.env.NUXT_ENV_C_GUID_DOCS_RF) || state.guidDocumentsRf;
      state.guidPassportRf = process.env.NUXT_ENV_C_GUID_PASSPORT_RF || state.guidPassportRf;
      state.guidBlr = process.env.NUXT_ENV_C_GUID_BLR || state.guidBlr;
      state.guidForeignDocTyp = process.env.NUXT_ENV_C_GUID_FOREIGN_DOC || state.guidForeignDocTyp;
      state.guidIsHseEducationLevel = process.env.NUXT_ENV_C_GUID_IS_HSE_EDUCATION_LEVEL || state.guidIsHseEducationLevel;
      state.guidIsHseEducationCountry = process.env.NUXT_ENV_C_GUID_IS_HSE_EDUCATION_COUNTRY || state.guidIsHseEducationCountry;
      state.guidIsHseEducationDocType = process.env.NUXT_ENV_C_GUID_IS_HSE_EDUCATION_DOC_TYPE || state.guidIsHseEducationDocType;
      state.guidIsHseEducationRegion = process.env.NUXT_ENV_C_GUID_IS_HSE_EDUCATION_REGION || state.guidIsHseEducationRegion;
      state.guidIsHseEducationOrgType = process.env.NUXT_ENV_C_GUID_IS_HSE_EDUCATION_ORGTYPE || state.guidIsHseEducationOrgType;
      state.guidIsHseEducationCity = process.env.NUXT_ENV_C_IS_HSE_EDUCATION_CITY || state.guidIsHseEducationCity;
      state.guidIsHseEducationOrgName = process.env.NUXT_ENV_C_IS_HSE_EDUCATION_ORG_NAME || state.guidIsHseEducationOrgName;
      state.guidEducationDocTypes = JSON.parse(process.env.NUXT_ENV_C_GUID_EDUCATION_DOC_TYPES) || state.guidEducationDocTypes;
      state.guidBenefitTypes = {
        orphanage: JSON.parse(process.env.NUXT_ENV_C_GUID_BENEFIT_TYPES_ORPHANAGE) || state.guidBenefitTypes.orphanage,
        disability: JSON.parse(process.env.NUXT_ENV_C_GUID_BENEFIT_TYPES_DISABILITY) || state.guidBenefitTypes.disability,
        combanant: JSON.parse(process.env.NUXT_ENV_C_GUID_BENEFIT_TYPES_COMBANANT) || state.guidBenefitTypes.combanant,
      };
      state.guidExtraQuotaType = process.env.NUXT_ENV_C_GUID_EXTRA_QUOTA_TYPE_GUID || state.guidRf;
    } catch (e) {
      // Не удалось распарсить значение
    }
  },
  SET_MESSAGE_FIELD(state, { stepNum, messageProp, codeProp }) {
    if (!stepNum || !codeProp) {
      return
    }
    let newArr = []
    if (state.messagesFields[stepNum]) {
      if (!!state.messagesFields[stepNum].find((e) => e.code === codeProp)) {
        newArr = state.messagesFields[stepNum].map((e) => {
          return {
            code: e.code,
            message: e.code === codeProp ? messageProp : e.message
          }
        })
      } else {
        newArr = [...state.messagesFields[stepNum], { code: codeProp, message: messageProp }]
      }
    } else {
      newArr = [{ code: codeProp, message: messageProp }]
    }

    state.messagesFields = {
      ...state.messagesFields,
      [stepNum]: newArr.filter((e) => e.message !== '')
    }
  },
  REFRESH_TRIGGER_PROGRAM(state) {
    state.triggerProgram = !state.triggerProgram
  },
  SET_INIT_FIELDS(state, value) {
    state.isInitFields = value ?? false
  },
  SET_SAVED_FILES(state, params) {

    const setFile = (val, key) => {
      if (!val || !key) return
      state.savedFiles[key] = val
    }

    if (Array.isArray(params)) {
      params.forEach((e) => {
        setFile(e.value, e.key)
      })
    } else {
      setFile(params.value, params.key)
    }
  },
  SET_CHANGED_FORM_STATE(state, value) {
    state.isChangedForm = value ?? false
  },
  SET_FORM_VIEW_MODE(state, value) {
    state.formViewMode = value ?? 'default'
  }
};
